export default __webpack_public_path__ + "listing-option.png";